
import { useState, useEffect } from 'react';
import { FaFilm,FaTv,FaBook } from 'react-icons/fa';

const InteractiveSelector = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animatedOptions, setAnimatedOptions] = useState<number[]>([]);
  
  const options = [
    {
      title: "爱乐之城",
      description: "Lalaland",
      image: "https://m.media-amazon.com/images/M/MV5BZDI0Y2FiMzgtMzkxNC00ODdmLTk0NWEtZDMwNjdmZGE2M2ZkXkEyXkFqcGc@._V1_.jpg",
      icon: <FaFilm size={24} className="text-white" />
    },
    {
      title: "三傻大闹宝莱坞",
      description: "3 Idiots",
      image: "https://m.media-amazon.com/images/M/MV5BMTU1Nzg0NzczMF5BMl5BanBnXkFtZTcwMzk0NDMwNQ@@._V1_.jpg",
      icon: <FaFilm size={24} className="text-white" />
    },
    {
      title: "星际穿越",
      description: "Interstellar",
      image: "https://m.media-amazon.com/images/M/MV5BMjA3NTEwOTMxMV5BMl5BanBnXkFtZTgwMjMyODgxMzE@._V1_.jpg",
      icon: <FaFilm size={24} className="text-white" />
    },
    {
      title: "葬送的芙莉莲",
      description: "葬送のフリーレン",
      image: "https://m.media-amazon.com/images/M/MV5BZTUzNmVkOTctZDk4MC00N2I4LTk1NTktMzE1YjE2MzFkZDRlXkEyXkFqcGc@._V1_FMjpg_UX1920_.jpg",
      icon: <FaTv size={24} className="text-white" />
    },
    {
      title: "强风吹拂",
      description: "風が強く吹いている",
      image: "https://i0.wp.com/anitrendz.net/news/wp-content/uploads/2019/04/Screen-Shot-2019-04-28-at-12.59.01-PM.png?w=1392&ssl=1",
      icon: <FaTv size={24} className="text-white" />
    },
    {
      title: "三体",
      description: "The Three-Body Problem",
      image: "https://m.media-amazon.com/images/I/91pU4vwOJUL._SL1500_.jpg",
      icon: <FaBook size={24} className="text-white" />
    }
  ];

  const handleOptionClick = (index: number) => {
    if (index !== activeIndex) {
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    const timers: number[] = [];
    
    options.forEach((_, i) => {
      const timer = window.setTimeout(() => {
        setAnimatedOptions(prev => [...prev, i]);
      }, 180 * i);
      timers.push(timer);
    });
    
    return () => {
      timers.forEach(timer => clearTimeout(timer));
    };
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[600px] bg-black font-mono text-white border-0 border-white"> 

      {/* Options Container */}
      <div className="options flex w-full min-w-[600px] h-[400px] mx-0 items-stretch overflow-hidden relative">
        {options.map((option, index) => (
          <div
            key={index}
            className={`
              option relative flex flex-col justify-end overflow-hidden transition-all duration-700 ease-in-out
              ${activeIndex === index ? 'active' : ''}
            `}
            style={{
              backgroundImage: `url('${option.image}')`,
              backgroundSize: activeIndex === index ? 'auto 100%' : 'auto 120%',
              backgroundPosition: 'center',
              backfaceVisibility: 'hidden',
              opacity: animatedOptions.includes(index) ? 1 : 0,
              transform: animatedOptions.includes(index) ? 'translateX(0)' : 'translateX(-60px)',
              minWidth: '60px',
              minHeight: '100px',
              margin: 0,
              borderRadius: 0,
              borderWidth: '4px',
              borderStyle: 'solid',
              borderColor: activeIndex === index ? '#fff' : '#000',
              cursor: 'pointer',
              backgroundColor: '#000',
              boxShadow: activeIndex === index 
                ? '0 0 0 4px #fff' 
                : '0 0 0 2px #000',
              flex: activeIndex === index ? '7 1 0%' : '1 1 0%',
              zIndex: activeIndex === index ? 10 : 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              position: 'relative',
              overflow: 'hidden',
              willChange: 'flex-grow, box-shadow, background-size, background-position'
            }}
            onClick={() => handleOptionClick(index)}
          >
            {/* Shadow effect */}
            <div 
              className="shadow absolute left-0 right-0 pointer-events-none transition-all duration-700 ease-in-out"
              style={{
                bottom: activeIndex === index ? '0' : '-40px',
                height: '120px',
                boxShadow: activeIndex === index 
                  ? 'inset 0 -120px 120px -120px #000, inset 0 -120px 120px -80px #000' 
                  : 'inset 0 -120px 0px -120px #000, inset 0 -120px 0px -80px #000'
              }}
            ></div>
            
            {/* Label with icon and info */}
            <div className="label absolute left-0 right-0 bottom-5 flex items-center justify-start h-12 z-2 pointer-events-none px-4 gap-3 w-full">
              <div className="icon min-w-[44px] max-w-[44px] h-[44px] flex items-center justify-center bg-black backdrop-blur-[10px] border-4 border-white flex-shrink-0 flex-grow-0 transition-all duration-200">
                {option.icon}
              </div>
              <div className="info text-white whitespace-pre relative">
                <div 
                  className="main font-black text-lg transition-all duration-700 ease-in-out"
                  style={{
                    opacity: activeIndex === index ? 1 : 0,
                    transform: activeIndex === index ? 'translateX(0)' : 'translateX(25px)'
                  }}
                >
                  {option.title}
                </div>
                <div 
                  className="sub text-base text-white transition-all duration-700 ease-in-out"
                  style={{
                    opacity: activeIndex === index ? 1 : 0,
                    transform: activeIndex === index ? 'translateX(0)' : 'translateX(25px)'
                  }}
                >
                  {option.description}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Custom animations */}
      <style>
        {`
        @keyframes slideFadeIn {
          0% {
            opacity: 0;
            transform: translateX(-60px);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fadeInFromTop {
          0% {
            opacity: 0;
            transform: translateY(-20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeInTop {
          opacity: 0;
          transform: translateY(-20px);
          animation: fadeInFromTop 0.8s ease-in-out forwards;
        }
        
        .delay-300 {
          animation-delay: 0.3s;
        }
        
        .delay-600 {
          animation-delay: 0.6s;
        }
        `}
      </style>
    </div>
  );
};

export default InteractiveSelector;
